import React, { useState } from 'react';
import '../../assets/css/floatingcontact.css';

const FloatingContact = () => {
    const [isOpen, setIsOpen] = useState(false);
    const phone = '0886299670';
    const phoneTitle = '0886.299.670';

    return (
        <>
            <div className="floating-btn" onClick={() => setIsOpen(!isOpen)}>
                <i className="fas fa-headset"></i>
            </div>
            <div className={`contact-menu ${isOpen ? 'open' : ''}`}>
                <a href={'https://www.facebook.com/NAVOSotiemkinhdoanh'} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-messenger"></i> Messenger
                </a>
                <a href={`https://zalo.me/0387556219`} target="_blank" rel="noopener noreferrer">
                    <i className="fas fa-comment"></i> Zalo
                </a>
                <a href={`tel:${phone}`}>
                    <i className="fas fa-phone"></i> Gọi {phoneTitle}
                </a>
            </div>
        </>
    );
};

export default FloatingContact;
